//Heroku URL

export const API_URL = "https://crm--app.herokuapp.com"
